"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const MathJax = __importStar(require("@nteract/mathjax"));
const remark_math_1 = __importDefault(require("./remark-math"));
const math = (props) => (react_1.default.createElement(MathJax.Node, null, props.value));
const inlineMath = (props) => (react_1.default.createElement(MathJax.Node, { inline: true }, props.value));
const MarkdownRender = (props) => {
    const newProps = Object.assign({}, props, { escapeHtml: false, plugins: [remark_math_1.default], renderers: Object.assign({}, props.renderers, { math,
            inlineMath }) });
    return react_1.default.createElement(react_markdown_1.default, Object.assign({}, newProps));
};
exports.default = MarkdownRender;
